<template>
  <div>
    <h1>
      Enter Pin
    </h1>

    <input v-model="pin1" type="text" ref="p1" @input="onIn('pin1', 'p2')" class="pin" placeholder="1234" maxlength="4" @keydown.enter="go">-
    <input v-model="pin2" type="text" ref="p2" @input="onIn('pin2', 'p3')" class="pin" placeholder="1234" maxlength="4" @keydown.enter="go">
    <br />
    <button @click="go">Enter Room</button>
    <p>
      Please use "Search" above or provide a " PIN" given by your teacher to enter your unique room.
    </p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      pin1: '',
      pin2: ''
    }
  },
  methods: {
    onIn (pIn, goFocus) {
      if (this[pIn].toString().length === 4) {
        if (this.$refs[goFocus]) {
          this.$refs[goFocus].focus()
        }
      }
    },
    go () {
      let pin = parseInt(`${this.pin1}${this.pin2}${this.pin3}`, 10)
      console.log(`${this.pin1}${this.pin2}${this.pin3}`, pin)
      this.$router.push(`/magic/${pin}`)
    }
  }
}
</script>

<style scoped>
.pin{
  appearance: none;
  outline: none;
  border: none;
  border-bottom: black solid 1px;
  display: inline;
  border-radius: 0px;
  width: 70px;
  height: 25px;
}
</style>
